import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		height: 200px;
	}
`;

export const titleBanners = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;
	border-left: 1px solid ${color.interface.lightGray2};
	border-right: 1px solid ${color.interface.lightGray2};

	> p {
		background-color: ${color.interface.white};
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		z-index: 10;
		text-align: center;
		font-size: 1.5rem;
		font-weight: 900;
		color: ${color.interface.lightGray};
	}
`;

export const areaSelectImg = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	border-radius: 5px;
	padding: 1rem;
	border: 2px dashed ${color.interface.lightGray2};
	background-color: ${color.interface.lightGray4};
	cursor: pointer;
	z-index: 1;

	> svg {
		font-size: 3rem;
		color: ${color.system.info};
	}

	> p {
		text-align: center;
		font-size: 1.8rem;
		color: ${color.system.info};
	}
`;

export const line = styled.div`
	top: 50%;
	position: absolute;
	width: 100%;
	height: 1px;
	background-color: ${color.interface.lightGray2};
`;

export const imageBanner = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 10;
	background-color: ${color.interface.lightGray4};

	> img {
		width: 100%;
		height: 100%;
		border-radius: 5px;
		object-fit: contain;
	}
`;

export const controlsBanner = styled.div`
	opacity: 0.9;
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 11;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	z-index: 10;
`;

export const buttons = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	background-color: ${color.interface.white};
	padding: 0.8rem;
	border-radius: 5px;

	> button {
		all: unset;
		padding: 0.5rem;
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 1.4rem;
	}
`;

export const editBtn = styled.button`
	color: ${color.system.info}!important;
	border-right: 1px solid ${color.interface.lightGray2}!important;
`;

export const deleteBtn = styled.button`
	color: ${color.system.error}!important;
`;
